// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__kBRZh","active":"MainHeader_active__qRM0G","dropdown":"MainHeader_dropdown__LB7vb"};